import { makeStyles, Theme } from "@material-ui/core";
import React from "react";

import { FONT_MED } from "../../styles/fonts";

interface SectionCardFieldProps {
  label: React.ReactNode;
  value: React.ReactNode;
  span?: number;
  className?: string;
  dataTestId?: string;
}

function isEmptyValue(value: React.ReactNode): boolean {
  if (value === null || value === undefined) return true;
  if (typeof value === "string" && value.trim() === "") return true;
  if (Array.isArray(value) && value.length === 0) return true;
  return false;
}

export default function SectionCardField({
  label,
  value,
  className = "",
  dataTestId,
}: SectionCardFieldProps) {
  const classes = useStyles();
  if (isEmptyValue(value)) return null;
  return (
    <div className={`${classes.root} ${className}`} data-testid={dataTestId}>
      <div className={classes.label}>{label}</div>
      <div className={classes.value}>
        {typeof value === "string" ? (
          <span className={classes.valueText}>{value}</span>
        ) : (
          value
        )}
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
    minWidth: 0,
  },
  label: {
    fontSize: 14,
    lineHeight: "20px",
    letterSpacing: "0.25px",
    color: theme.palette.text.secondary,
    wordBreak: "break-word",
    ...FONT_MED,
  },
  value: {
    minWidth: 0,
    wordBreak: "break-word",
  },
  valueText: {
    fontSize: 14,
    lineHeight: "20px",
    letterSpacing: "0.25px",
    color: theme.palette.text.primary,
    ...FONT_MED,
  },
}));
